<template>
    <div id="admin_excluded_referrals_page" class="container-fluid">
        <button @click="resetModalData" type="button" class="btn btn-secondary main-button pull-right" data-toggle="modal" data-target="#add_new_referral">+ Add New Referral Name</button>

        <div class="modal fade" id="add_new_referral" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Add New Referral Name</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <input id="new_referral_name" v-model="new_referral_name" type="text" class="form-control">
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn" data-dismiss="modal">Cancel</button>
                        <button @click="addNewReferralName" :disabled="!new_referral_name" type="button" class="btn btn-success">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <v-client-table :data="tableData" :columns="columns" :options="options">
            <div slot="referral_to_exclude" slot-scope="props">
                <div v-if="!props.row.edit_mode">{{ props.row.referral_to_exclude }}</div>
                <input v-if="props.row.edit_mode" type="text" class="form-control edit-excluded-referral" :value="props.row.referral_to_exclude">
            </div>

            <div slot="actions" slot-scope="props" class="text-right">
                <button v-if="!props.row.edit_mode" @click="toggleEditMode(props.row.id)" class="btn btn-info reverse">Edit</button>
                <button v-if="props.row.edit_mode" @click="save(props.row.id, $event)" class="btn btn-success reverse">Save</button>
                <button v-if="props.row.edit_mode" @click="toggleEditMode(props.row.id)" class="btn cancel-editing">Cancel</button>
                <button v-if="!props.row.edit_mode" @click="remove(props.row.id)" class="btn btn-danger reverse">Delete</button>
            </div>
        </v-client-table>

        <div class="text-center">
            <button @click="$router.go(-1)" type="button" class="btn btn-info">Back</button>
        </div>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();
        },

        data() {
            return {
                new_referral_name: '',
                columns: ['referral_to_exclude', 'actions'],
                tableData: [],
                options: {
                    headings: {
                        referral_to_exclude: 'Referrals',
                        actions:              ''
                    },
                    sortable: ['referral_to_exclude'],

                    perPage: 20,
                    perPageValues: [],
                    texts: {
                        count: 'Showing {from} to {to} of {count} referrals|{count} referrals|One referral',
                        filter: '',
                        filterPlaceholder: 'Search referrals...',
                        noResults: 'No matching referrals'
                    },
                    skin: 'table'
                }
            }
        },

        methods: {
            fetchServerData() {
                axios.all([
                    axios.get('/api/admin/excluded-referrals')
                ])
                .then(axios.spread(excludedReferrals => {
                    _.each(excludedReferrals.data, item => {
                        item.edit_mode = false;
                    });

                    this.tableData = excludedReferrals.data;
                }));
            },

            resetModalData() {
                this.new_referral_name = '';
            },

            addNewReferralName() {
                $('#add_new_referral').modal('hide');

                axios.post('api/admin/excluded-referrals', {referral: this.new_referral_name}).then(() => {
                    this.$notify({
                        type: 'success',
                        text: 'Referral has been successfully added.'
                    });

                    this.fetchServerData();
                });
            },

            toggleEditMode(id) {
                const index = _.findIndex(this.tableData, {id: id});

                if (index > -1) {
                    this.tableData[index].edit_mode = !this.tableData[index].edit_mode;
                }
            },

            save(id, event) {
                const newReferralName = $(event.target).closest('tr').find('.edit-excluded-referral').val();
                const index           = _.findIndex(this.tableData, {id: id});

                if (index > -1) {
                    this.tableData[index].edit_mode = false;
                }

                axios.put(`api/admin/excluded-referrals/${id}`, {
                    referral: newReferralName
                }).then(() => {
                    this.$notify({
                        type: 'success',
                        text: 'Referral has been successfully updated.'
                    });

                    this.fetchServerData();
                });
            },

            remove(id) {
                this.confirmation('Are you sure you want to delete this referral?', () => {
                    axios.delete(`api/admin/excluded-referrals/${id}`).then(() => {
                        this.$notify({
                            type: 'success',
                            text: 'Referral has been successfully deleted.'
                        });

                        this.fetchServerData();
                    });
                });
            }
        }
    }
</script>

<style lang="scss">
    #admin_excluded_referrals_page {
        .edit-excluded-referral {
            width: auto;
            height: 3.4rem;
        }

        .cancel-editing {
            padding: 0.8rem 1.65rem;
        }

        .VueTables__table {
            table-layout: fixed;
        }
    }
</style>
